import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { DeviceDetectionService } from '../common/device-detection.service';
import { AppViewMode, SettingsService } from '../common/settings.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-unsupported-device',
  templateUrl: './unsupported-device.component.html',
  styleUrls: ['./unsupported-device.component.scss'],
})
export class UnsupportedDeviceComponent implements AfterViewInit {
  isDeviceUnsupported = false;

  messageDescription =
    'Please scan the QR code with a mobile device to continue.';

  isQRCodeLoading = false;

  @ViewChild('qrCodeContainer') qrCodeContainer: ElementRef;

  constructor(
    private deviceDetectionService: DeviceDetectionService,
    private settingsService: SettingsService
  ) {
    // A device other than a phone is not supported in default view mode
    this.isDeviceUnsupported =
      this.settingsService.settings.viewMode === AppViewMode.DEFAULT &&
      !this.deviceDetectionService.isMobile();
  }

  ngAfterViewInit() {
    // If the device is unsupported, generate a QR code which links to the TAP URL
    if (this.isDeviceUnsupported) {
      /**
       * This code involves asynchronous operations.
       * Instead of making `ngAfterViewInit` asynchronous, we use `setTimeout()` to defer the execution of the logic.
       * If `ngAfterViewInit` were asynchronous, Angular would throw an ExpressionChangedAfterItHasBeenCheckedError`
       * because the view's change detection cycle completes before the asynchronous code finishes updating the component's state.
       */
      setTimeout(async () => {
        const tagId = this.settingsService.settings.tagId;

        if (!!tagId) {
          this.messageDescription = `Please use a mobile device to open this link or scan the QR code above to continue`;
          this.isQRCodeLoading = true;

          const QRCode = await import('qrcode');
          const canvas = document.createElement('canvas');
          await QRCode.toCanvas(canvas, `${environment.TAP_URL}/${tagId}`, {
            width: 200,
            margin: 0,
            color: {
              dark: '#FFF',
              light: '#000',
            },
          });

          this.isQRCodeLoading = false;
          this.qrCodeContainer.nativeElement.appendChild(canvas);
        }
      });
    }
  }
}
